import './side-info.scss';

import {
  AltynBankStatus,
  EuBankV2Status,
  FfbBankStatus
} from '@/components/Shared/constants/banks-statuses';
import { BankNames } from '@/constants';
import { useAppSelector } from '@/store';

import { banksToShowVehicleInfo } from '../../constants';
import { ChosenBankInfo, VehicleInfo } from '../../features';

const altynStatusesToShowVehicleInfo = [
  AltynBankStatus.FinancedWaitingForModificationBeforePledge,
  AltynBankStatus.WaitingOfFinancing,
  AltynBankStatus.Financed
];

const SideInfo: React.FC = () => {
  const { selectedBank, isEuBankOfflineProcess } = useAppSelector(
    (state) => state.financingStep
  );
  const { tsModalValues } = useAppSelector((state) => state.newOrder);

  const status: string = selectedBank?.status.code ?? '';
  const bankName: string = selectedBank?.bank.name ?? '';

  const isEuBankV2: boolean = bankName === BankNames.euBankV2;
  const isAltyn: boolean = bankName === BankNames.altyn;
  const isFreedomBank: boolean = bankName === BankNames.ffb;

  const checkEuBankV2Status: boolean =
    !isEuBankV2 ||
    isEuBankOfflineProcess ||
    (status !== EuBankV2Status.MobileClient && !!tsModalValues.vin);
  const checkAltynStatus: boolean =
    isAltyn &&
    altynStatusesToShowVehicleInfo.includes(status as AltynBankStatus);
  const checkFreedomBankStatus: boolean =
    isFreedomBank &&
    (status === FfbBankStatus.VehicleRegistration || !!tsModalValues.vin);

  const shouldShowVehicleInfo: boolean =
    checkEuBankV2Status &&
    (banksToShowVehicleInfo.includes(bankName as BankNames) ||
      checkAltynStatus ||
      checkFreedomBankStatus);

  return (
    <div className="side-info">
      <ChosenBankInfo />

      {shouldShowVehicleInfo && (
        <div className="side-info__vehicle-info">
          <VehicleInfo />
        </div>
      )}
    </div>
  );
};

export default SideInfo;
